import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function MainAccordion({ title, data, isOpen = false }) {
  return (
    <Accordion
      defaultExpanded={isOpen}
      elevation={2}
      sx={{
        px: 2,
        mt: 1,
        borderRadius: 2,
        "&:before": {
          display: "none",
        },
        boxShadow: (theme) => `0 2px 8px ${theme.palette.divider}`,
      }}
    >
      <AccordionSummary
        sx={{
          p: 0,
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          p: 0,
        }}
      >
        <Typography>{data}</Typography>
      </AccordionDetails>
    </Accordion>
  );
}
